<div *ngFor="let step of steps" class="completed-documents">
    <h5>{{ step.name }}</h5>
    <ng-container *ngIf="documentationResponses != null">
        <div
            class="step-documents"
            *ngFor="let entity of documentationResponses[step.value]"
        >
            <ng-container *ngIf="entity.forms.length > 0">
                <h6>{{ entity.name }}</h6>
                <div class="document" *ngFor="let form of entity.forms">
                    <span>
                        <a
                            *ngIf="canViewOrganisation"
                            (click)="
                                showFormResponse(
                                    step.value,
                                    entity,
                                    form.entity.formId
                                )
                            "
                            [tooltip]="
                                requiringEntitySourceLookup[
                                    findRequiringEntityLookupValue(
                                        form.requiringEntityType,
                                        form.requiringEntityId
                                    )
                                ] != null
                                    ? 'Required by ' +
                                      requiringEntitySourceLookup[
                                          findRequiringEntityLookupValue(
                                              form.requiringEntityType,
                                              form.requiringEntityId
                                          )
                                      ]
                                    : ''
                            "
                            placement="top"
                        >
                            {{ form.entity.formName }}
                        </a>
                        <ng-container
                            *ngIf="!canViewOrganisation"
                            [tooltip]="
                                requiringEntitySourceLookup[
                                    findRequiringEntityLookupValue(
                                        form.requiringEntityType,
                                        form.requiringEntityId
                                    )
                                ] != null
                                    ? 'Required by ' +
                                      requiringEntitySourceLookup[
                                          findRequiringEntityLookupValue(
                                              form.requiringEntityType,
                                              form.requiringEntityId
                                          )
                                      ]
                                    : ''
                            "
                            placement="top"
                        >
                            {{ form.entity.formName }}
                        </ng-container>
                        <field-validation-indicator
                            *ngIf="step.validate"
                            [hasValue]="
                                entity.formResponses[form.entity.formId]
                                    .length > 0
                            "
                            [valid]="form.completed"
                            [required]="form.required"
                        >
                        </field-validation-indicator>
                        <ng-container *ngIf="canViewOrganisation">
                            <a
                                *ngIf="step.editable"
                                class="action"
                                (click)="editForm(step.value, entity, form)"
                                >Edit</a
                            >
                            <a
                                class="action"
                                *ngIf="
                                    entity.formResponses[form.entity.formId]
                                        .length > 0
                                "
                                (click)="
                                    printFormResponse(
                                        entity.formResponses[
                                            form.entity.formId
                                        ][0],
                                        step.value
                                    )
                                "
                            >
                                Print
                            </a>
                        </ng-container>
                        <!--
                        <a class="action"
                        (click)="printFormTemplate(form.entity.formId, step.value)">
                            Print Template
                        </a> -->
                    </span>
                </div>
            </ng-container>
            <ng-container
                *ngIf="entity.attachments && attachmentsByRequirementId"
            >
                <div *ngFor="let attachmentType of entity.attachments">
                    <h6>{{ attachmentType.entity.name }}</h6>
                    <div
                        class="document"
                        *ngFor="
                            let attached of attachmentsByRequirementId[
                                attachmentType.entity.id
                            ]
                        "
                    >
                        <a
                            *ngIf="canViewOrganisation"
                            [downloadUrl]="attached.downloadUrl"
                            [tooltip]="
                                requiringEntitySourceLookup[
                                    findRequiringEntityLookupValue(
                                        attachmentType.requiringEntityType,
                                        attachmentType.requiringEntityId
                                    )
                                ] != null
                                    ? 'Required by ' +
                                      requiringEntitySourceLookup[
                                          findRequiringEntityLookupValue(
                                              attachmentType.requiringEntityType,
                                              attachmentType.requiringEntityId
                                          )
                                      ]
                                    : ''
                            "
                            placement="top"
                        >
                            {{ attached.name }}
                        </a>
                        <ng-container
                            *ngIf="!canViewOrganisation"
                            [tooltip]="
                                requiringEntitySourceLookup[
                                    findRequiringEntityLookupValue(
                                        attachmentType.requiringEntityType,
                                        attachmentType.requiringEntityId
                                    )
                                ] != null
                                    ? 'Required by ' +
                                      requiringEntitySourceLookup[
                                          findRequiringEntityLookupValue(
                                              attachmentType.requiringEntityType,
                                              attachmentType.requiringEntityId
                                          )
                                      ]
                                    : ''
                            "
                            placement="top"
                        >
                            {{ attached.name }}
                        </ng-container>
                    </div>
                    <em
                        *ngIf="
                            !attachmentsByRequirementId[
                                attachmentType.entity.id
                            ]
                        "
                    >
                        No attached documents
                    </em>
                </div>
            </ng-container>
        </div>
        <div *ngIf="!hasData[step.value]">No documentation required</div>
    </ng-container>
</div>
<p *ngIf="!hasData">No extra documentation</p>
